<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['dischargepatient']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-consentform size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Consent Form</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :busy="IsBusy"
                show-empty
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading data...</strong></div></template>
              <template #empty><div class="text-center text-muted my-3"><strong>No data found</strong></div></template>
              <template #cell(index)="data">
                {{ ((currentPage - 1) * perPage) + data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(service)="data">
                {{ data.item.service.name }}
              </template>
            
              <template #cell(price)="data">
                {{ data.item.service.serviceprice }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">

                <b-button @click="edit(data.item.id,data.item.patient.patient_id,data.item.service.service_name,data.item.witness,data.item.service.serviceprice,data.item.service.category)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <router-link :to="{ path: '/printpatientconsentform',  query: { patient_id: data.item.patient.patient_id,id: data.item.id}}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> </router-link>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Consent Form</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-consentform" centered title="New Consent Form" title-class="font-18" hide-footer>
        <form @submit.prevent="addConsentForm">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="visits" :custom-label="customLabel" label="name"></multiselect>
            </div>
            
            <div class="form-group mb-2">
                      <label>Service Category</label> <small class="text-danger">*</small>
                      <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
                    </div>
                    <div class="form-group mb-2">
                      <label>Service Name</label> <small class="text-danger">*</small>
                      <multiselect v-model="service_name" label="name" :options="services"></multiselect>
                    </div>
                    <div class="form-group mb-2">
                      <label>Service Price</label> <small class="text-danger">*</small>
                      <input v-model="prices" label="name" type="number" class="form-control" >
                    </div>
                    <!-- <div class="row" v-if="userData.permissions['edit_service_cost']==1">
                    <div class="form-group mb-2" >
                      <label>Service Cost</label> <small class="text-danger">*</small>
                      <input v-model="service_price"  required type="number" class="form-control" />
                    </div>
                    </div>
                    <div v-else>
                     <div class="row justify-content-center">
                       <div class="form-group mb-2" >
                      <label>Service Cost</label> <small class="text-danger">*</small>
                      <input v-model="service_price" readonly required type="number" class="form-control" />
                       </div>
                      </div>
                    </div>
            -->
            <div class="form-group mb-2">
            <label>Witness</label>
              <input v-model="witness" type="text" class="form-control"/>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-consentform')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-consentform" centered title="Edit Consent Form" title-class="font-14" hide-footer>
        <form @submit.prevent="editConsentform">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient</label>
              <b-form-select v-model="patient" required :options="visits" class="mb-3 form-control" value-field="patient_id" text-field="name"></b-form-select>
            </div>
            <div class="form-group mb-2">
              <label>Service Category</label> <small class="text-danger">*</small>
              <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
              <label>Service Name</label> <small class="text-danger">*</small>
              <multiselect v-model="service_name" label="name"  :options="services"></multiselect>
            </div>
            <div class="form-group mb-2">
                      <label>Service Price</label> <small class="text-danger">*</small>
                      <input v-model="prices" label="name" type="number" class="form-control" >
                    </div>
            <!-- <div class="row" v-if="userData.permissions['edit_service_cost']==1">
              <div class="form-group mb-2" >
                <label>Service Cost</label> <small class="text-danger">*</small>
                <input v-model="service_price"  required type="number" class="form-control" />
              </div>
            </div> 
            <div v-else>
              <div class="row justify-content-center">
                <div class="form-group mb-2" >
              <label>Service Cost</label> <small class="text-danger">*</small>
              <input v-model="service_price" readonly required type="number" class="form-control" />
                </div>
              </div> 
            </div> -->
           
            <div class="form-group mb-2">
            <label>Witness</label>
              <input v-model="witness" type="text" class="form-control"/>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-consentform')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-consentform" centered title="Delete Consent Form " title-class="font-18" hide-footer>
        <form @submit.prevent="removeConsentForm">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Consent Form for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-consentform')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientconsentformMethods,visitMethods, patientconsentformComputed,  visitComputed, serviceCategoryMethods,serviceCategoryComputed } from "@/state/helpers";

export default {
  page: {
    title: "Consent Forms",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Consent Form",
      items: [ {text: "Dashboard",to: "/",}, {text: "Consent Forms",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      services:[],
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'patientct', label: 'Patient Contact', visible: true },
          { key: 'service', label: 'Service', visible: true },
          { key: 'prices', label: 'Cost', visible: true },
          { key: 'witness', label: 'Witness', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
         
        ],
      id:'',
      patient:'',
      service:'',
      service_name:'',
      prices:'',
      date_of_birth:new Date().toLocaleDateString('fr-CA'),
      service_cost:'',
      service_category: "",
      // service_name: "",
      // name:'',
      price:'',
      service_price: "",
      witness:"",
    };
  },
  computed: {
    ...patientconsentformComputed,
    ...visitComputed,
    ...serviceCategoryComputed,
    List() { return this.TotalRows; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientconsentforms.map((d) => ({...d }))},
    IsBusy() { return this.isBusy; },
  },
  created() {
    
    this.fetchServiceCategory();
  },
  mounted() {
    this.loadPatientConsentForms();
    this.fetchVisits();
  },
  watch: {
    currentPage() {
      this.loadPatientConsentForms();
    },
    perPage() {
      this.currentPage = 1;
      this.loadPatientConsentForms();
    },
    filter() {
      this.currentPage = 1;
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.loadPatientConsentForms();
      }, 300);
    },
  },
  methods: {
    ...patientconsentformMethods,
    ...visitMethods,
    ...serviceCategoryMethods,
    customLabel ({ patient_id, name, telephone, serviceprice,  price }) {
      return `${patient_id} – ${name} – ${telephone}– ${serviceprice}– ${price}`
    },
    async loadPatientConsentForms() {
      this.isBusy = true;
      const response = await this.fetchPatientConsentForms({
        page: this.currentPage,
        per_page: this.perPage,
        search: this.filter || "",
      });
      this.TotalRows = response.data.pagination?.total || 0;
      this.isBusy = false;
    },
    async FilterCategory(){
      let url = `/servicebycategory/${this.service_category.id}`;
        await axios.get(url).then((response) => {
          this.services = response.data.services;
        });
    },
    edit(id,patient,service_name,witness,serviceprice,category,service_cost,prices){
      this.id=id;
      this.patient=patient;
      this.service_name=service_name;
      this.witness=witness;   
      this.prices=prices;
      // this.service_price=serviceprice;  
      this.service_cost=service_cost;         
      this.service_category=category;      
      this.$bvModal.show('edit-consentform')
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-consentform')
    },
    // async FilterPrice(){
    //     let url = `/serviceprice/${this.service_name.id}`;
    //     await axios.get(url).then((response) => {
    //       this.service_price = response.data.price;
    //       if (this.payment_type=='3') {
    //         this.balance=this.account_balance-this.service_price;
    //         if (this.balance<0) {
    //           this.balancebtn=false;
    //           this.error="Insufficient Balance";
    //         } else {
    //           this.error='';
    //           this.balancebtn=true;
    //         }            
    //       } else {
    //           this.error='';
    //           this.balancebtn=true;
    //         }  
    //       });
    //   },
    async addConsentForm() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("service", this.service);
      formData.append("witness", this.witness);
      formData.append("service_category", this.service_category.id);
      formData.append("service_name", this.service_name.id);
      formData.append("prices", this.prices);
      let url = "/addpatientconsentform";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatientConsentForms();
        this.fetchVisits();
        this.$bvModal.hide('new-consentform');
        this.patient="";
        this.service="";
        this.witness="";
        this.service_category="";
        this.service_name="";
        // this.service_price="";
        this.prices="";
        this.$toast.success("New Patient Consent Form Added");
      }
      });
    },
   
    async FilterPatient(){
      let url = `/findpatient/${this.patient_name}`;
        await axios.get(url).then((response) => {
        if (response.data.patients) {
          this.telephone = response.data.patients[0].telephone;
          this.dateofbirth = response.data.patients[0].date_of_birth;
          this.address = response.data.patients[0].address;
          this.nin = response.data.patients[0].nin;
          this.email = response.data.patients[0].email;
          this.gender = response.data.patients[0].gender;
        }});
        
        let url1 = `/findpatientbalance/${this.patient_name}`;
        await axios.get(url1).then((response) => {
          if (response.data.balance>0) {
            this.error = "Patient has a pending balance "+ response.data.balance +" "+ this.userData.currency; 
          }
        });
    },
    async editConsentform(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("patient", this.patient);
      formData.append("prices", this.prices);
      formData.append("witness", this.witness);
      formData.append("service_category", this.service_category.id);
      formData.append("service_name", this.service_name.id);
      // formData.append("service_price", this.service_price);
   
    let url = "/updatepatientconsentform";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatientConsentForms();
        this.$bvModal.hide('edit-consentform');
        this.patient="";
        // this.service="";
        this.witness="";
        this.service_category="";
        this.service_name="";
        // this.service_price="";
        this.prices="";
          this.$toast.success("Patient Consent Form Updated");
      }
    });
    },

    async removeConsentForm() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removepatientconsentform";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatientConsentForms();
        this.$bvModal.hide('delete-consentform');
        this.$toast.error("Patient Consent Form Deleted");
      }
    });
    },
  },
};
</script>
